import { Row, Col, Button } from "react-bootstrap";
import FeaturedViewers from "../components/FeaturedViewers";
import introTour from "../tours/IntroductoryTour";
import { ActiveTour, UserInfo } from "../helper/Context";
import { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { canRequestDOI } from "../helper/BusinessLogic";

const TutorialsPage = (props) => {
  const { setActiveTour } = useContext(ActiveTour);
  const { userInfo } = useContext(UserInfo)
  let location = useLocation();
  useEffect(()=>{
    if(location && location.state && location.state.focusElement){
      const t = document.getElementById(location.state.focusElement);
      if (t){
        t.scrollIntoView();
      }
    }
  },[location]) 
  const youtubeVideoIds = [
    "KfBT5RgM3as",
    "weRoFHbxGMc",
    "HQgGAu-TycY",
    "1-FVH_O8sTY?si=zUXZH1b2xhS9cxbq",
    "bvlcKF5YgyU",
    "9v4FExsHUoI",
  ];
  return (
    <>
      <Row className="justify-content-center">
        <div className="main-container-narrower">


          <h2 className="TitleText mb-4">Overview</h2>
          {userInfo ?
            <div>
              <center>
                <Button onClick={() => setActiveTour(introTour)}>
                  Click to revisit the introductory tour!
                </Button>
              </center>
            </div> : null}


          <h4>
            <b>Examples</b>
          </h4>

          <Row>
            {youtubeVideoIds.map((videoId) => (
              <Col key={videoId} md={6} className="mb-4">
                <div
                  className="video-container"
                  style={{
                    position: "relative",
                    paddingBottom: "56.25%", // 16:9 aspect ratio (height/width)
                    height: 0,
                    overflow: "hidden",
                  }}
                >
                  <iframe
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                    }}
                    src={`https://www.youtube.com/embed/${videoId}?si=Ohob0ygUqCeCyeSS`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </Col>
            ))}
          </Row>
          <br></br>
          <center>
            <h4>
              <b>Documentation</b>
            </h4>
          </center>
          <p></p>
          <h4 ><b>Creating visuals</b></h4>
          <div>
            <a href="#supported_types">Supported file types for loading images </a>
          </div>

          <div>
            <a href="#models3d">Uploading images and 3D models</a>
          </div>

          <div>
            <a href="#proteins">Protein and small molecule visualisations</a>
          </div>
          <div>
            <a href="#landmarks">Adding landmarks, audio, and animated tours to 3D models and image stacks</a>
          </div>


          <br></br>

          <h4 ><b>Viewing and presenting Snorkle visuals</b></h4>
          <div>
            <a href="#viewer_controls">Basic multichannel image viewing tools</a>
          </div>

          <div>
            <a href="#volume_viewer_controls">Special volumetric 3D viewing options for image stacks</a>
          </div>

          <div>
            <a href="#changing_initial_view">Changing the initial view for image stacks</a>
          </div>

          <div>
            <a href="#zoomable_controls">Zoomable image viewer</a>
          </div>

          <div>
            <Link to="/powerpoint">Presenting Snorkle visuals using PowerPoint</Link>
          </div>

          <br></br>

          <h4 ><b>Sharing and embedding visuals</b></h4>
          <div>
            <a href="#social_media">Sharing visuals via X or Facebook</a>
          </div>
          <div>
            <a href="#embedding">Embedding visuals in a webpage</a>
          </div>

          <div>
            <a href="#sharing_url">Sharing visual links via URL or QR code</a>
          </div>

          <br></br>
          <h4 ><b>Digital Object Identifiers (DOIs)</b></h4>
          <div>
            <a href="#about_doi">About DOIs</a>
          </div>
          <div>
            <a href="#doi">Requesting a DOI</a>
          </div>
          <br></br>

          <a id="supported_types"><h4><b>Supported image types</b></h4></a>
          <div>
            <b>Flat image uploads:</b> Snorkle accepts standard flat image formats, compressed or raw, including .png, .jpg, .jpeg, .tif, .tiff, .czi, or .dcm (DICOM) files. Very high resolution images (with the exception of .dcm files) will be displayed as "zoomable," dynamically-loading tiled images.
            <p></p><b>Image stacks:</b> Files must be either in a multi-page .tiff format or compressed (.zip) multipage .tiff file or archive. For multi-slice DICOM files such as CT scan or MRIs, these can be uploaded as a zipped folder containing the individual .dcm files associated with each slice or else as a single multi-page .dcm file.
            <p></p><b>Size limits:</b> The maximum size for a single upload (either single image or zipped folder of multiple images) varies by account tier: 50 MB at the free tier, 100 MB at premium, and 250 MB at unlimited.

          </div>
          <br></br>

          <a id="models3d"><h4><b>3D models</b></h4></a>
          <div>
            Currently, Snorkle supports importing a wide range of 3D model formats, including .stl, .glb, .obj, and .ply. We also support importing models from <a href="https://www.sketchfab.com" target="_blank"> Sketchfab</a>. Using Snorkle, these can also be accessed, viewed, and embedded into PPT. Here is an example of an embedded imported .glb:
            <center><iframe src="https://vis.snorkle.io/P7XsUGHvXM3gqzcaQmbbPx_u5tjDv7cfPjQGAcGhirA=/viewer.html" width="100%" height="400" /></center>
            <br></br>

            {/* If using a model from Sketchfab, simply copy the URL (as in the screenshot below), and paste into the Web Resource input field in "Use web resource."
            <center><img src="https://vis.snorkle.io/sketchfab_samplescreen.png" width="75%"></img>
            <p></p></center> */}

          </div>
          <br></br>

          <a id="proteins"><h4><b>Chemistry visualizations</b></h4></a>
          <div>
            Snorkle currently supports creating interactive visuals of molecules from the <a href="https://www.rcsb.org/" target="_blank"> Protein Data Bank</a> and <a href="https://pubchem.ncbi.nlm.nih.gov/" target="_blank">PubChem</a>. If you are not using Snorkle's search function, you can simply copy the PDB code or compound ID (CID) and paste into the Web Resource input field in "Use web resource." Embedded within a site, an interactive molecule (GFP) looks like this:
            <p></p>
            <br></br>
            <center><iframe src="https://vis.snorkle.io/UdqjHtubYL9jkzbSH9mvBtY72jQjATGF-giADyUj5W8=.html" width="100%" height="400" /></center>

          </div>
          <br></br>
          <div>
            And an interactive small molecule (EGFR inhibitor, PubChem compound 163388532) looks like this:
            <p></p>
            <br></br>
            <center><iframe src="https://vis.snorkle.io/-XjPH8Tmiwz46xoNcasTnmV7gc8komtuf-12TrCj8J0=.html" width="100%" height="400" /></center>

          </div>
          <br></br>
          <a id="landmarks"><h4><b>Landmarks, audio, and animated tours</b></h4></a>
          <div>
            For 3D models, you can add landmark-based animated tours using the "Add/Edit Landmarks" button when viewing your list of visuals (seen below).
            <p></p>
            <center><img src="https://vis.snorkle.io/add-edit-landmarks-button.jpg" width="100%"></img></center>
          </div>
          <br></br>
          <div>
            Within the landmark editor interface, you can add landmarks by clicking "New Landmark" and following the instructions for selecting points and choosing camera angles.
            <p></p>
            <center><img src="https://vis.snorkle.io/add-edit-landmarks.jpg" width="100%"></img></center>
          </div>
          <br></br>
          <div>
            The pencil icon can be used to edit previously added landmarks. In this window, beyond adjusting the title and text for that landmark, you can set the duration and add audio tracks such as voiceovers.

            <p></p>
            <center><img src="https://vis.snorkle.io/edit-landmark-ui.jpg" width="50%"></img></center>
          </div>
          <br></br>

          <a id="viewer_controls"><h4><b>Basic multichannel image viewing tools</b></h4></a>
          <div>
            Snorkle visuals are "theater mode" by default, meaning they are displayed with minimal buttons, knobs, and sliders. However, Snorkle visuals can be inspected in detail using the image viewing options. Clicking the "settings" button on the bottom left corner of a visual reveals both channel adjustment and display options.
            <p></p><center>
              <img src="https://vis.snorkle.io/image_adjustments_palette.png" width="75%"></img>
              <p></p></center>
            <b>Try it out below:</b> Embedded within a site, this particular fluorescence image stack looks like this (note that the initial view/display can be customized):
            <p></p>
            <center><iframe src="https://vis.snorkle.io/zebc5XQUNvry3AGtsBDkHcYdNj72_AdCIj3m2zQPET4=/viewer.html" width="100%" height="400" /></center>
          </div>
          <br></br>

          <a id="volume_viewer_controls"><h4><b>Viewing image stacks in 3D</b></h4></a>
          <div>
            For image stacks with more than <b>10 slices</b>, toggling the "3D" button will create a volumetric 3D rendering of the data. The buttons "fast," "standard," and "detailed" that appear refer to rendering quality, which can affect the smoothness of rotation and zooming on machines with lower graphics performance. The default rendering is "detailed." Another button that appears in 3D mode is the "rotate" button which makes the rendered object slowly rotate until stopped by a mouse / tap.
            <br></br>
            <p></p><center>
              <img src="https://vis.snorkle.io/volumetric_options.png" width="75%"></img>
              <p></p></center>
            Thus, a single image stack can be adjusted to have a multitude of appearances and data inspection capabilities ranging from standard 2D presentation to exotic-colored sliced volumes, e.g.:

            <p></p> <center>
              <img src="https://vis.snorkle.io/brain3d_viewoptions.png" width="75%"></img>
              <p></p></center>
            <b>Try it out below:</b> The example below shows an RGB image stack derived from a PET scan. Individual channels can be adjusted in threshold and gain.
            <p></p>
            <center><iframe src="https://vis.snorkle.io/8380Vb0gJnLiKIsqB305ow98CShGP78RAp3yqbOxexE=/viewer.html" width="100%" height="400" /></center>

            <p></p>
            <b>Note on rendering quality on Safari for desktops:</b> Volumetric renderings may be of slightly lower quality when displayed in Safari (on desktops). Any other browser should be used. Rendering quality is still high on iPhones and Android devices.

          </div>
          <br></br>
          <p></p>

          <a id="changing_initial_view"><h4><b>Changing initial view of image stacks / volumetric rendering</b></h4></a>
          <div>
            Image stacks can require fiddling around with to achieve a desired aesthetic. For instance, the volumetric MRI renderings above involve switching to 3D, changing to night mode, adjusting the low threshold, turning on rotation, advancing the stack slider to reveal subcortical regions, etc. Rather than spending time adjusting this on the fly during a presentation (and for the benefit of sharing attractive visualizations), you can set the default initial view settings from within your list of visuals using the "Change initial view" button. That will open up a window with your data item, which you can then adjust the view settings on. Clicking "Save current view" will then cause that visual link to open with the new custom view. <b>It may take up to 15 minutes to propagate that changed initial view over the web.</b>
          </div>
          <br></br>


          <a id="zoomable_controls"><h4><b>Zoomable image viewer</b></h4></a>
          <div>
            High resolution images (&lt;2048 x 2048) will be displayed as dynamically loading tiled image viewers. This is particularly applicable for whole-slide pathology imagery. These visuals may take additional time to process; <b>very high resolution files can take upwards of 15 minutes to create a Snorkle visual version.</b> Below is an interactive example of this:
          </div>
          <p></p>
          <center><iframe src="https://vis.snorkle.io/axcI7mLhucvRLlYQQNCmLF6rAOLREhbeTxlrEhJ2ZGM=.html" width="100%" height="400" /></center>

          <br></br>

          <a id="social_media"><h4><b>Sharing via X or Facebook</b></h4></a>
          <div>
            You can share your Snorkle visuals from your list of Visuals by using the Share button in the bottom right of each visual card. Sharing on Facebook or X will create a link preview that includes a thumbnail image, if you have uploaded one for that visual, as well as the title and description. Visuals from Sketchfab automatically have thumbnails associated with them, but they can be changed using the edit option.
          </div>
          <center>          <p></p>
            <img src="https://vis.snorkle.io/tweet_image.png" width="50%"></img>
            <p></p>
            <img src="https://vis.snorkle.io/facebook_sharing.png" width="50%"></img>
            <p></p>
            <img src="https://vis.snorkle.io/share_visual_options.jpg" width="50%"></img>
            <p></p>
          </center>
          You can enable or restrict other people from sharing or embedding your visual by checking or unchecking the share button option in the editing options:
          <center>
            <p></p>
            <img src="https://vis.snorkle.io/enable_share_button.png" width="50%"></img>
            <p></p>
          </center>


          <br></br>

          <a id="embedding"><h4><b>Embedding visuals</b></h4></a>
          <div>
            You can embed Snorkle visuals into a website by copying the embed HTML code snippet offered as one of the sharing options, as below.
          </div>
          <p></p>
          <center>
            <img src="https://vis.snorkle.io/share_visual_options_embed.jpg" width="50%"></img>
            <p></p>
          </center>

          <br></br>

          <a id="sharing_url"><h4><b>Sharing via URL or QR code</b></h4></a>
          <div>
            Maximizing mobile compatibility and experience is a core value for Snorkle. All visuals created using Snorkle can be shared and viewed on mobile through the automatically generated QR codes. These codes can be copied and pasted from each visual's card in your list. The QR codes can also be auto-inserted into your slides when using the <Link to="/powerpoint"><b>Snorkle Viewer add-in for PowerPoint</b></Link>. Otherwise, simply copying and sharing the Snorkle URL for your visual will enable anyone to view it in the browser.
          </div>
          <br></br>
          <center>
            <img src="https://vis.snorkle.io/QR_card_MRI_visual.png" width="75%"></img>
            <p></p>
          </center>
          <br></br>
          <a id="about_doi"><h4><b>About DOIs</b></h4></a>
          <div>
            A Digital Object Identifier (DOI) is a unique, persistent identifier used to reference digital content like research articles, datasets, and reports. It ensures that even if a webpage moves, the DOI link will still direct users to the correct resource. <a href="https://www.crossref.org/about" target="_blank" rel="noopener noreferrer" >Crossref</a>, of which Snorkle Labs is a member, is a DOI registration agency that assigns and maintains DOIs for scholarly content. We register DOIs with Crossref, linking them to metadata like author names, publication dates, and abstracts.

            DOIs are widely recognized and indexed by databases such as Google Scholar, PubMed, and Scopus, making them crucial for citation tracking and academic visibility. Inclusion in these databases depends on publisher policies and indexing agreements.
          </div>
          <br></br>

          <a id="doi"><h4><b>Requesting a DOI</b></h4></a>
          <div>
            {canRequestDOI(userInfo) ?
              <>Users with unlimited and group accounts can request DOIs for their own visuals through our <Link to="/doi">DOI request form</Link>. Visuals for which a DOI is requested will be screened and may take up to 24 hours to fully issue, assuming no issues have been identified. You will receive a notification and DOI link when it has passed screening. If we find issues, we will respond with items that need attention or correction. Sample issues might include lack of references, missing author metadata, questions regarding accuracy of scientific descriptions, or others.
              </> :
              <>Users with unlimited and group accounts can request DOIs for their own visuals. Visuals for which a DOI is requested will be screened and may take up to 24 hours to fully issue, assuming no issues have been identified. You will receive a notification and DOI link when it has passed screening. If we find issues, we will respond with items that need attention or correction. Sample issues might include lack of references, missing author metadata, questions regarding accuracy of scientific descriptions, or others.
              </>}
          </div>
          <br></br>


        </div>
      </Row>
    </>
  );
};

export default TutorialsPage;
